import { ElementRef, ViewContainerRef, Directive, OnInit, Input, HostBinding } from '@angular/core';
import { IconsSet } from './iconsSet.class';


@Directive({
   selector: '[icons]',
})
export class IconsDirective implements OnInit {
   @Input('icons') private config: string;
   @HostBinding('title') get hostTitle() { return this.title; }
   private title: string;

   constructor(
      public hostRef: ElementRef<HTMLElement>,
      public viewContainerRef: ViewContainerRef,
   ) { }


   ngOnInit() {
      const host = this.hostRef.nativeElement;
      const [setId, id, size] = this.config.split(':');
      const set = IconsSet.pool.find(set => set.id === setId);

      if (set === undefined) { // #Didn't find set
         console.error(`Set with id '${setId}' doesn't exist`);
         return null;
      }

      const match = set.objects.find(ic => ic.id === id);

      if (match === undefined) { // #Didn't find icon
         console.error(`Icon with id '${this.config}' in set with '${setId}' doesn't exist`);
         return null;
      }

      const svg = set.getSvg(match);
      const sized = size ? setSizesToSvg(svg, +size) : svg;

      host.innerHTML = sized;
      this.title = set.getTitle(match);
   }
}


function setSizesToSvg(svg: string, size: number): string {
   let processed = svg.replace(/width="[0-9]*"/, `width=${size}`);

   processed = processed.replace(/height="[0-9]*"/, `height=${size}`);

   return processed;
}